import React from 'react'
import './Copyrightpolicy.css'

const ContentArchivalPolicy = () => {
    return (
   <div>
            <div id="heading">
                <h3>Content Archival Policy</h3>
            </div>
            <div class="conntent-conntainer">
                    
                </div>
            </div>
     
      

    )
}

export default ContentArchivalPolicy
